import { FC, useEffect, useState } from 'react';
import CustomerSchedulingCalendar from '@components/CustomerSchedulingCalendar';
import useNoodleApi from '@hooks/useNoodleApi';
import { getProductById } from '@tsClient';
import ProgressIndicator from '@components/ProgressIndicator';
import deserializeQueryStringItem from '@helpers/deserializeQueryStringItem';
import { useRouter } from 'next/router';
import Buttons from '@components/Buttons/Buttons';
import s from '@components/CartBookingForm/CartBookingForm.module.scss';
import Spacer from '@components/Spacer';

type Props = {
  productId: string;
  priceId: string;
  onSelect: (data: { sessionTime: string; sessionDuration: number }) => Promise<void>;
  onFinish?: () => void;
};

const CartBookingForm: FC<Props> = ({ productId, priceId, onSelect, onFinish }) => {
  const router = useRouter();
  const {
    data,
    getData: getProduct,
  } = useNoodleApi(getProductById);
  const [hasSelectedTime, setHasSelectedTime] = useState(false);
  const selectedDate = deserializeQueryStringItem(router.query.selectedDate, { type: 'string' });

  useEffect(() => {
    setHasSelectedTime(false);
  }, [selectedDate]);

  useEffect(() => {
    getProduct({ id: productId });
  }, [productId, getProduct]);

  const handleSelect = async (newTime: { sessionTime: string, sessionDuration: number }): Promise<void> => {
    setHasSelectedTime(true);
    onSelect(newTime);
  };

  if (!data?.product) {
    return <ProgressIndicator />;
  }

  return (
    <div className={s.container}>
      <h1 className='body-sm-bold'>Select your desired date and time for this appointment:</h1>
      <div className={s.divider} />
      <CustomerSchedulingCalendar
        priceId={priceId}
        product={data.product}
        selectedDate={selectedDate}
        onDateTimeSelect={handleSelect}
      />
      {onFinish && (
        <>
          <Spacer size='24px' />
          <Buttons disabled={!hasSelectedTime} isSecondary isFullWidth onClick={onFinish}>
            Next
          </Buttons>
        </>
      )}
    </div>
  );
};

export default CartBookingForm;
